import React from 'react';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';

import { Footer } from '../global/elements';
import { FirstColumnContainer, SecondColumnContainer, StyledLayout } from './elements';

interface ITwoColumnLayout {
  firstColumn: React.ReactNode;
  secondColumn: React.ReactNode;
}

export const TwoColumnLayout = ({ firstColumn, secondColumn }: ITwoColumnLayout) => {
  const breakpoints = useBreakpoint();
  const isDesktopVersion = breakpoints.xl;

  return (
    <>
      <StyledLayout>
        {isDesktopVersion ? <FirstColumnContainer>{firstColumn}</FirstColumnContainer> : null}

        <SecondColumnContainer>{secondColumn}</SecondColumnContainer>
      </StyledLayout>

      <Footer>
        <img src="/images/GGS_Logo.png" alt="logo" />
      </Footer>
    </>
  );
};

